<section class="coming-soon" [dir]="lang.getDir()">
  <div class="container">
    <h2 class="section-title animate-slide-in">
      {{ 'coming.title' | translate }}
    </h2>

    <p class="section-subtitle animate-fade-in">
      {{ 'coming.subtitle' | translate }}
    </p>

    <div class="features-grid">
      <div class="feature-box animate-fade-in-delay" *ngFor="let feature of features">
        <span class="emoji">{{ feature.emoji }}</span>
        <h3>{{ feature.title | translate }}</h3>
        <p>{{ feature.desc | translate }}</p>
      </div>
    </div>

    <div class="subscribe-box animate-pop-in">

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="subscribe-box animate-pop-in">
  <input type="email" formControlName="email" placeholder="{{ 'coming.emailPlaceholder' | translate }}" required />
  <button type="submit">{{ 'coming.notify' | translate }}</button>
</form>


    </div>
  </div>
</section>
